import { memo } from 'react';

import { SettingsSubSideNavItem } from '~/components/v2/components/workspace/settings-nav/item/SettingsSubSideNavItem';
import { SettingsSubSideNavSectionHeader } from '~/components/v2/components/workspace/settings-nav/item/SettingsSubSideNavSectionHeader';
import { useWorkspaceSettingsNavItems } from '~/components/v2/components/workspace/settings-nav/useWorkspaceSettingsNavItems';

export const SettingsSubSideNavWorkspaceSection = memo(() => {
  const { items } = useWorkspaceSettingsNavItems();

  return (
    <section className="flex flex-col" data-testid="SETTINGS_SUB_SIDE_NAV_WORKSPACE_SECTION">
      <SettingsSubSideNavSectionHeader className="pt-1" data-testid="SETTINGS_SUB_SIDE_NAV_WORKSPACE_HEADER">
        Workspace Settings
      </SettingsSubSideNavSectionHeader>
      {items.map((item) => (
        <SettingsSubSideNavItem item={item} key={item.id} />
      ))}
    </section>
  );
});

SettingsSubSideNavWorkspaceSection.displayName = 'SettingsSubSideNavWorkspaceSection';
